export default __webpack_public_path__ + "static/media/news88.e6d89da7.jpg";